import { Box, Container, Grid } from "@mui/material";
import {
  InfoOperater,
  Loading,
  NoviOperater,
  PodaciOIdentifikaciji,
  Poruka,
  UpravljanjePodacimaOstaliOperateri,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useContext, useRef } from "react";
import axios from "axios";
import { TIP_INFO_PORUKE } from "../../enums";
import { Context } from "../../context";
import { useMojiPodaci, useOstaliOperateri } from "../../hooks";

type Izdavatelj = {
  oznaka: string;
  euSifra: string;
};

type VrstaIdentifikatora = {
  id: number;
  opis: string;
};

type Identifikator = {
  id: number;
  vrstaIdentifikatora: VrstaIdentifikatora;
  drzavaIzdavatelj: Izdavatelj;
  identifikacijskiBroj: string;
};

type TipElektronickeAdrese = {
  id: number;
  opis?: string;
};

type ElektronickaAdresa = {
  adresa: string;
  tip: TipElektronickeAdrese;
};

type Drzava = {
  naziv?: string;
  oznaka: string;
  euSifra: string;
};

type Adresa = {
  drzava: Drzava;
  mjesto: string;
  regija?: string;
  postanskiBroj?: string;
  okrug?: string;
  ulica?: string;
  kucniBroj?: string;
};

type Naziv = {
  id: number;
  naziv: string;
};

export type Operater = {
  id: number;
  adrese: Adresa[];
  elektronickeAdrese?: ElektronickaAdresa[];
  naziv: Naziv;
  drzava: Drzava;
  identifikator?: Identifikator[];
};

export interface FormValues {
  odabraniOperater: number | null;
  noviOperater: Operater | null;
  ostaliOperateri: Operater[];
  drzave: Drzava[];
  elektronickeAdrese: TipElektronickeAdrese[];
  loading: boolean;
  infoPoruka: string;
  tipInfoPoruke: number | null;
}

const Index = () => {
  const methods = useForm<FormValues>({
    defaultValues: {
      odabraniOperater: null,
      ostaliOperateri: [],
      drzave: [],
      loading: true,
      infoPoruka: "",
      tipInfoPoruke: null,
      noviOperater: null,
    },
  });
  const watchAll = methods.watch();
  const formRef = useRef(null);
  const [{ token }] = useContext(Context);
  const ostaliOperateri = useOstaliOperateri(token, methods);
  const { operaterPlatforme, drzave } = useMojiPodaci(methods);

  const onSubmit = async (data: FormValues) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/operateri/ostali-operateri`,
        {
          ostaliOperateri: data.ostaliOperateri,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        methods.setValue("infoPoruka", response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            methods.setError(error.fieldName, { message: error.error })
          );
          const errorIndex = parseInt(
            error.response.data.errors[0].fieldName.match(/\[(.*?)\]/)[1]
          );
          methods.setValue(
            "odabraniOperater",
            methods.getValues("ostaliOperateri")[errorIndex].id
          );
        }
      }
    }
  };

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component={"form"}
              onSubmit={(e) => {
                methods.clearErrors();
                methods.handleSubmit(onSubmit)(e);
              }}
              ref={formRef}
            >
              <PodaciOIdentifikaciji />
              <UpravljanjePodacimaOstaliOperateri />
            </Box>
            <NoviOperater />
          </Grid>
        </Grid>
      </Container>
      <Loading />
      <Poruka />
    </FormProvider>
  );
};

export default Index;
